import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.manifestoContainer = document.querySelector('.c-manifesto_container');
    }

    play(e){
        if (e.way == 'enter') {
            this.manifestoContainer.classList.add('-visible');
        } else {
            this.manifestoContainer.classList.remove('-visible');
        }
    }
}
